<!--销售退货单列表-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.EntpCusName"
                        remote
                        filterable
                        allow-create
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">退货单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.ReturnCode"
                        v-filter-special-char="searchData.ReturnCode"
                        placeholder="请输入退货单号"
                    ></el-input>
                    <div class="search-name">销售单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="请输入销售单号"
                    ></el-input>
                    <div class="search-name">退款方式</div>
                    <el-select style="width: 150px" class="search-item" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">退款状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.RState" style="width: 100px">
                        <el-option v-for="item in returnStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.DeliveryStat">
                        <el-option v-for="item in deliveryStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">业务员</div>
                    <el-select style="width: 100px" v-model="searchData.SId" class="search-item" filterable clearable size="small" placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">创建时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.print }}</el-button>
                    <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>销售总额</p>
                            <p>￥{{ statData.saleTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>退货商品总数</p>
                            <p>{{ statData.returnCount }}</p>
                        </div>
                        <div class="data-item">
                            <p>退款总额</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.returnTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>已退总计</p>
                            <p>￥{{ statData.refundTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>待退款总计</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.surplusTotal }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn salereturnpay-table">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; cursor: pointer"
                    highlight-current-row
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                >
                    <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnCode.IsShow"
                        :width="columnShowSets.ReturnCode.Width > 0 ? columnShowSets.ReturnCode.Width + 'px' : '220px'"
                        :label="columnShowSets.ReturnCode.ColumnName"
                        prop="ReturnCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="scope.row.ApplyCount + '条待确认'" class="mark" type="danger" v-if="scope.row.ApplyCount > 0">
                                {{ scope.row.ReturnCode }}
                            </el-badge>
                            {{ scope.row.ApplyCount > 0 ? '' : scope.row.ReturnCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OrderCode.IsShow"
                        :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '170px'"
                        :label="columnShowSets.OrderCode.ColumnName"
                        prop="OrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <!-- <el-button @click="gotoSalesDetails(scope.row)" type="text">{{ scope.row.OrderCode }}</el-button> -->
                             <el-button @click.native.stop="copyCode(scope.row)" title="单击单号复制，双击查看详情" type="text">{{ scope.row.OrderCode }}</el-button>                      
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.EntpCusName.IsShow"
                        :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                        :label="columnShowSets.EntpCusName.ColumnName"
                        prop="EntpCusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="SurplusMoney"
                        v-if="columnShowSets.SurplusMoney.IsShow"
                        :min-width="columnShowSets.SurplusMoney.Width > 0 ? columnShowSets.SurplusMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.SurplusMoney.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ReturnMoney"
                        v-if="columnShowSets.ReturnMoney.IsShow"
                        :min-width="columnShowSets.ReturnMoney.Width > 0 ? columnShowSets.ReturnMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.ReturnMoney.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="PayTypeName"
                        v-if="columnShowSets.PayTypeName.IsShow"
                        :min-width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                        :label="columnShowSets.PayTypeName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.RefundStateName.IsShow"
                        :width="columnShowSets.RefundStateName.Width > 0 ? columnShowSets.RefundStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.RefundStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.RefundStateName == '已完成退款'" class="c-active">{{ scope.row.RefundStateName }}</i>
                            <i v-else>{{ scope.row.RefundStateName }}</i></template
                        ></el-table-column
                    >
                    <el-table-column
                        prop="Refund"
                        v-if="columnShowSets.Refund.IsShow"
                        :min-width="columnShowSets.Refund.Width > 0 ? columnShowSets.Refund.Width + 'px' : '100px'"
                        :label="columnShowSets.Refund.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.InWarehouseStateName.IsShow"
                        :width="columnShowSets.InWarehouseStateName.Width > 0 ? columnShowSets.InWarehouseStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.InWarehouseStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.InWarehouseStateName == '已入仓'" class="out-active">{{ scope.row.InWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.InWarehouseStateName }}</i></template
                        >
                    </el-table-column>
                    <el-table-column
                        prop="SName"
                        v-if="columnShowSets.SName.IsShow"
                        :min-width="columnShowSets.SName.Width > 0 ? columnShowSets.SName.Width + 'px' : '80px'"
                        :label="columnShowSets.SName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ReturnTime"
                        sortable
                        v-if="columnShowSets.ReturnTime.IsShow"
                        :min-width="columnShowSets.ReturnTime.Width > 0 ? columnShowSets.ReturnTime.Width + 'px' : '160px'"
                        :label="columnShowSets.ReturnTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Creator"
                        v-if="columnShowSets.Creator.IsShow"
                        :min-width="columnShowSets.Creator.Width > 0 ? columnShowSets.Creator.Width + 'px' : '80px'"
                        :label="columnShowSets.Creator.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column label="操作" fixed="right" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.salesReturnsPaymentFunc && scope.row.IsCanRefund"
                                    @click="gotoDetails('cpayment', scope.row)"
                                    type="text"
                                    size="small"
                                    >{{ permission.salesReturnsPaymentFunc }}</el-button
                                >
                                <el-button v-else-if="permission.editAndConfirm && scope.row.IsCanRefund" @click="gotoDetails('cpayment', scope.row)" type="text" size="small">{{
                                    permission.editAndConfirm
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="saleReturn"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
                <div class="dialog-content" v-if="dialogVisible">
                    <printContent @closeDialog="closeDialog" :printIds="idList"></printContent>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            tableCode: 'SalesReturnPayment',
            timeVisible: false,
            statisticsVisible: false,
            multipleSelection: null,
            dialogVisible: false,
            startDateOps: {
                disabledDate: time => {
                    if (this.searchData.eTime != '') {
                        return time.getTime() > new Date(this.searchData.EndDate);
                    }
                }
            },
            endDateOps: {
                disabledDate: time => {
                    if (this.searchData.sTime != '') {
                        return time.getTime() <= new Date(this.$util.getOtherDay(this.searchData.StartDate, -1));
                    }
                }
            },
            tableData: [],
            searchData: {
                RState: '5',
                PayType: [],
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                DeliveryStat: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            statData: {
                returnTotal: 0,
                saleTotal: 0,
                refundTotal: 0,
                returnCount: 0,
                surplusTotal: 0
            },
            tableDataLength: 0,
            permission: {},
            formloading: false,
            reasonFormData: {},
            returnStateList: [
                { Text: '全部', Value: '' },
                { Text: '未退款', Value: '5' },
                { Text: '已退定金', Value: '10' },
                { Text: '已完成退款', Value: '15' }
            ],
            deliveryStateList: [
                { Text: '全部', Value: '' },
                { Text: '未入仓', Value: '5' },
                { Text: '部分入仓', Value: '20' },
                { Text: '已入仓', Value: '15' },
                { Text: '不需入仓', Value: '10' }
            ],
            payWayList: [],
            SIdList: [],
            idList: [],
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnCode: { ColumnName: '', IsShow: false, Width: 0 },
                SurplusMoney: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnMoney: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                RefundStateName: { ColumnName: '', IsShow: false, Width: 0 },
                Refund: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnTime: { ColumnName: '', IsShow: false, Width: 0 },
                InWarehouseStateName: { ColumnName: '', IsShow: false, Width: 0 },
                Creator: { ColumnName: '', IsShow: false, Width: 0 },
                SName: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            clickTimer: null,  //添加一个计时器
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.initSearchSelectData();
        this.getTableData();
        this.searchCustom();
        this.permission = this.$util.getPermission('salesReturnsPayment');
        this.$util.setEnterEvent(this, this.$route.fullPath);

        let that = this;
        Vue.component('printContent', function (resolve) {
            that.$util.getPrintComponents(4).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printSaleReturn'], resolve);
                }
            });
        });
    },
    watch: {
        NeedRefresh(value) {
            if (value) {
                this.getTableData();
                this.$store.commit('updateNeedRefresh', false);
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$store.state.needRefresh;
        }
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.SReturnId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.dialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].SReturnId);
            }
            this.idList = idList;
        },
        // 跳转到关联销售单
        gotoSalesDetails(row) {
            this.$router.push(`/salesManage/salesOrder/edit?type=1&id=${row.EntpCusOId}&fromLv2=revenue_p`);
        },
        resetSearch() {
            this.searchData = {
                RState: '',
                PayType: [],
                EntpCusName: '',
                ReturnCode: '',
                DeliveryStat: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            let SReturnId = item ? item.SReturnId : '';
            let EntpCusOId = item ? item.EntpCusOId : '';
            this.$router.push(`/financeManage/salesReturns/payment/confirmSalesRefunds?action=${type}&SReturnId=${SReturnId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetSaleReturnOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.statData.returnTotal = data.ReturnTotal;
                    this.statData.saleTotal = data.SaleTotal;
                    this.statData.refundTotal = data.RefundTotal;
                    this.statData.returnCount = data.ReturnCount;
                    this.statData.surplusTotal = data.SurplusTotal;
                    this.tableData = data.ReturnOrderList;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(row, column, cell, event) {
            clearTimeout(this.clickTimer); //清除未执行的定时器
            if (row) {
                if(column.property == "OrderCode"&&row.OrderCode){
                    this.gotoSalesDetails(row)
                }
                else
                    this.gotoDetails('see', row);
            }
            event.stopPropagation()            
        },
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张退货单打印');
                return;
            }
            this.dialogVisible = true;
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'SurplusMoney':
                            this.columnShowSets.SurplusMoney.IsShow = item.IsShow;
                            this.columnShowSets.SurplusMoney.Width = item.Width;
                            this.columnShowSets.SurplusMoney.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnCode':
                            this.columnShowSets.ReturnCode.IsShow = item.IsShow;
                            this.columnShowSets.ReturnCode.Width = item.Width;
                            this.columnShowSets.ReturnCode.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnMoney':
                            this.columnShowSets.ReturnMoney.IsShow = item.IsShow;
                            this.columnShowSets.ReturnMoney.Width = item.Width;
                            this.columnShowSets.ReturnMoney.ColumnName = item.ColumnName;
                            break;
                        case 'InWarehouseStateName':
                            this.columnShowSets.InWarehouseStateName.IsShow = item.IsShow;
                            this.columnShowSets.InWarehouseStateName.Width = item.Width;
                            this.columnShowSets.InWarehouseStateName.ColumnName = item.ColumnName;
                            break;
                        case 'RefundStateName':
                            this.columnShowSets.RefundStateName.IsShow = item.IsShow;
                            this.columnShowSets.RefundStateName.Width = item.Width;
                            this.columnShowSets.RefundStateName.ColumnName = item.ColumnName;
                            break;
                        case 'Refund':
                            this.columnShowSets.Refund.IsShow = item.IsShow;
                            this.columnShowSets.Refund.Width = item.Width;
                            this.columnShowSets.Refund.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnTime':
                            this.columnShowSets.ReturnTime.IsShow = item.IsShow;
                            this.columnShowSets.ReturnTime.Width = item.Width;
                            this.columnShowSets.ReturnTime.ColumnName = item.ColumnName;
                            break;
                        case 'Creator':
                            this.columnShowSets.Creator.IsShow = item.IsShow;
                            this.columnShowSets.Creator.Width = item.Width;
                            this.columnShowSets.Creator.ColumnName = item.ColumnName;
                            break;
                        case 'SName':
                            this.columnShowSets.SName.IsShow = item.IsShow;
                            this.columnShowSets.SName.Width = item.Width;
                            this.columnShowSets.SName.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        copyCode(row){
            let that=this;
            clearTimeout(that.clickTimer); //清除未执行的定时器
            that.clickTimer = setTimeout(function () {
                let inputNode = document.createElement('input')  // 创建input
                inputNode.value = row.OrderCode // 赋值给 input 值
                document.body.appendChild(inputNode) // 插入进去
                inputNode.select() // 选择对象
                document.execCommand('Copy') // 原生调用执行浏览器复制命令
                inputNode.className = 'oInput'
                inputNode.style.display = 'none' // 隐藏
                that.$message.success('复制成功')
            }, 500);
        },         
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.cell {
    .el-button {
        padding: 5px;
    }
}
</style>
<style lang="less">
.salereturnpay-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
